import * as React from "react";
import { SideBarBase } from "../SideBarBase";

import { MenuElement } from "../../interfaces";
import { URLS } from "../../utils";

interface Props {
  history: any;
  readyToContinue?: boolean;
}

const SideBarFC: React.FC<Props> = ({ history, readyToContinue = true }) => {
  const menu: MenuElement[] = [
    {
      title: "Users",
      path: URLS.admin.dashboard,
    },
    {
      title: "Video Catalyst",
      path: URLS.editor.videoProjects.root,
    },
    {
      title: "Video Scripts",
      path: URLS.videoScripts,
    },
    {
      title: "Prompt Studio",
      path: URLS.admin.promptStudio,
    },
    {
      title: "Leaderboards",
      path: URLS.admin.leaderboards,
    },
    {
      title: "Tools",
      path: URLS.admin.tools,
    },
  ];

  return <SideBarBase history={history} menu={menu} readyToContinue={readyToContinue} />;
};

export const AdminSideBar = SideBarFC;
